/* eslint-disable react-hooks/exhaustive-deps */
import dynamic from "next/dynamic"
import { useRouter } from "next/router"
import { ChangeEvent, useEffect, useMemo, useState } from "react"
import { useLayoutData } from "../../../../utils/contexts/LayoutContext"
import { FindSelectOptionProps, FindSelectProps } from "../FindDesignTypes"
import Stack from "@mui/material/Stack"
import { filterUrl } from "../Find"
import { PageType } from "../../../../pages/_app"
import { FilterBaseProps } from "../Find.types"

const FilterDropDown = ({
  filters,
  mmbr,
  pageUrl,
  isMobile
}: FilterBaseProps) => {
  const router = useRouter()
  const { partnerSiteFull, templatePath } = useLayoutData()
  const [localUrl, setLocalUrl] = useState<string>('')

  const path = templatePath === PageType.RBhuPP ? `${templatePath}/templates/${partnerSiteFull?.content?.templateId ?? 'AutoraTemplate'}` : templatePath

  const FindSelect = useMemo(() => dynamic<FindSelectProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindSelect)), [path])
  const FindSelectOption = useMemo(() => dynamic<FindSelectOptionProps>(() => import(`../../../../design/${path}/_findDesign/Design`).then((style) => style.FindSelectOption)), [path])

  useEffect(() => {
    filters?.items?.map((item) => item.selected ? setLocalUrl(filterUrl(filters, item, undefined, pageUrl, mmbr)) : '')
  }, [])
  
  const handleSelectChange = (e: ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value
    setLocalUrl(url)
    router.push(url, undefined, { scroll: false })
  }
  return (
    <Stack
      m={isMobile ? 2 : undefined}
      width={'100%'}
    >
      <FindSelect onChange={handleSelectChange} value={localUrl}>
        {filters?.items?.map((item, i) => (
          <FindSelectOption key={i} value={filterUrl(filters, item, undefined, pageUrl, mmbr)}>{item.title}</FindSelectOption>
        ))}
      </FindSelect>
    </Stack>
  )
}

export default FilterDropDown